import { render, staticRenderFns } from "./UpgradeMemberByDownTipDialog.vue?vue&type=template&id=0caf2309&scoped=true&"
import script from "./UpgradeMemberByDownTipDialog.vue?vue&type=script&lang=js&"
export * from "./UpgradeMemberByDownTipDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeMemberByDownTipDialog.vue?vue&type=style&index=0&id=0caf2309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf2309",
  null
  
)

export default component.exports